import type { VisaCategory } from './types';

/** i18n phrase keys for each visa category */
export const VISA_PHRASE_KEYS: Record<VisaCategory, string> = {
  visa_free: 'ui.visa_free',
  visa_on_arrival: 'ui.visa_on_arrival',
  e_visa: 'ui.e_visa_required',
  visa_required: 'ui.visa_required',
  not_allowed: 'ui.entry_not_allowed',
};

/** DaisyUI badge classes for each visa category */
export const VISA_COLORS: Record<VisaCategory, string> = {
  visa_free: 'badge-success',
  visa_on_arrival: 'badge-info',
  e_visa: 'badge-warning',
  visa_required: 'badge-error',
  not_allowed: 'badge-error',
};

/** Display order for visa categories (best → worst) */
export const VISA_CATEGORY_ORDER: VisaCategory[] = [
  'visa_free',
  'visa_on_arrival',
  'e_visa',
  'visa_required',
  'not_allowed',
];
